import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../_services/shared.service';
import { GlobalService } from '../_services/global.service';
import { IndexedDbService } from '../_services/indexed-db.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Output() expandedChange = new EventEmitter<boolean>();
  public isExpanded = false;
  public isAdminUser = false;
  public isAdmiGruponUser = false;
  public isAdmiGlobalGruponUser = false;

  constructor(
    public router: Router,
    private sharedService: SharedService,
    private globalService: GlobalService,
    private db: IndexedDbService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Reativo às permissões (BehaviorSubject emite o valor atual na hora da inscrição
    // e de novo sempre que setPermissions() for chamado em qualquer lugar do app) —
    // evita ler isAdminGrupo()/isAdminGlobalGrupo() antes das permissões chegarem do backend.
    this.globalService.permissions$.subscribe(() => {
      this.isAdminUser = this.globalService.isAdmin();
      this.isAdmiGruponUser = this.globalService.isAdminGrupo();
      this.isAdmiGlobalGruponUser = this.globalService.isAdminGlobalGrupo();
      this.cdr.detectChanges();
    });
    this.sharedService.sidebarToggle$.subscribe(() => this.toggle());
  }

  toggle(): void {
    this.isExpanded = !this.isExpanded;
    this.expandedChange.emit(this.isExpanded);
  }

  close(): void {
    if (this.isExpanded) {
      this.isExpanded = false;
      this.expandedChange.emit(false);
    }
  }

  logout(): void {
    const logoutUrl = `https://uatwebmtz.b2clogin.com/uatwebmtz.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/logout?post_logout_redirect_uri=${environment.redirectUrl}/login`;
    this.db.clear();
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = logoutUrl;
  }
}
